export default axios => ({
  getPoint: id => axios.get(`defining-points/${id}`).then(x => x.data.data)
})
